import { render } from "./TopSellingCourses.vue?vue&type=template&id=496f2a98"
import script from "./TopSellingCourses.vue?vue&type=script&lang=js"
export * from "./TopSellingCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__